export default __webpack_public_path__ + "9c21f78a00ebc9b565c94ff1a524c880.svg";